/* eslint-disable */
import gql from 'graphql-tag';

export const ALL_BOOKINGS = gql`
  query allBooking(
    $page: Int
    $orderBy: String
    $isHandled: Boolean
    $isHistory: Boolean
    $isCanceled: Boolean
    $businessOwnerId: Int
    $search: String
  ) {
    allBookings(
      page: $page
      orderBy: $orderBy
      isHandled: $isHandled
      isCanceled: $isCanceled
      isHistory: $isHistory
      businessOwnerId: $businessOwnerId
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      ... on ActivityBookingType {
        id
        trekksoftId
        referenceNumber
        creationTime
        cancellationTime
        guestFirstName
        guestPhoneNumber
        guestEmail
        platform
        isCanceled
        isCanceledWithMain
        isHandled
        isRelated
        startingDate
        endingDate
        deactivationBooking
        checkInTime
        checkOutTime
        bookingType
        activityNotes
        guestLastName
        activity {
          id
          pricesType
          title
          schedule
          scheduleType
        }
        bookedAddOns {
          addOnCount
          totalPrice
          addOn {
            title
          }
        }
        guests {
          guestsNumber
          totalPrice
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        relatedAccommodationBooking {
          id
          fromDate
          toDate
          accommodation {
            id
            title
            prices {
              day
            }
          }
          guests {
            totalPrice
            guestsNumber
            participant {
              participant
            }
          }
          payments {
            currency {
              currency
            }
            totalPrice
          }
          bookedAddOns {
            addOn {
              title
            }
            totalPrice
            addOnCount
          }
        }
      }
      ... on AccommodationBookingType {
        id
        referenceNumber
        creationTime
        isCanceled
        isCanceledWithMain
        isHandled
        isRelated
        bookingType
        bookingNotes
        cancellationTime
        guestFirstName
        guestLastName
        guestPhoneNumber
        guestEmail
        platform
        fromDate
        toDate
        deactivationBooking
        expediaReferenceNumber
        guests {
          totalPrice
          guestsNumber
          participant {
            participant
          }
        }
        bookedAddOns {
          addOn {
            title
          }
          totalPrice
          addOnCount
        }
       
        bookedMandatoryFees {
        mandatoryFee {
          title
        }
        mandatoryFeeCount
        totalPrice
        }
        
        accommodation {
          id
          title
          checkInTime
          checkOutTime
          prices {
            day
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        relatedActivitiesBookings {
          id
          startingDate
          endingDate
          activity {
            id
            pricesType
            title
            scheduleType
          }
          guests {
            totalPrice
            guestsNumber
            participant {
              participant
            }
          }
          payments {
            currency {
              currency
            }
            totalPrice
          }
          bookedAddOns {
            addOn {
              title
            }
            totalPrice
            addOnCount
          }
        }
      }
    }
    numberOfBookingsPages(
      isCanceled: $isCanceled
      isHistory: $isHistory
      isHandled: $isHandled
      businessOwnerId: $businessOwnerId
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      totalBookingsNumber {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
      pages {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
    }
  }
`;

export const ACCOMMODATIONS_BOOKINGS = gql`
  query accommodationsBookings(
    $page: Int
    $orderBy: String
    $isHandled: Boolean
    $isHistory: Boolean
    $isCanceled: Boolean
    $startPeriod: Date
    $endPeriod: Date
    $businessOwnerId: Int
    $search: String
  ) {
    accommodationsBookings(
      page: $page
      orderBy: $orderBy
      isHandled: $isHandled
      isCanceled: $isCanceled
      isHistory: $isHistory
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      businessOwnerId: $businessOwnerId
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      id
      referenceNumber
      creationTime
      isCanceled
      isCanceledWithMain
      isHandled
      isRelated
      bookingType
      bookingNotes
      cancellationTime
      guestFirstName
      guestLastName
      guestPhoneNumber
      guestEmail
      platform
      expediaReferenceNumber
      fromDate
      toDate
      deactivationBooking
      guests {
        totalPrice
        guestsNumber
        participant {
          participant
        }
      }
      payments {
        currency {
          currency
        }
        totalPrice
      }
      bookedAddOns {
        addOn {
          title
        }
        addOnCount
        totalPrice
      }
      accommodation {
        id
        title
        productCode
        checkInTime
        checkOutTime
        guestsNumber
        prices {
          day
        }
      }
      relatedActivitiesBookings {
        id
        startingDate
        endingDate
        activity {
          id
          pricesType
          title
          scheduleType
        }
        bookedAddOns {
          addOnCount
          totalPrice
          addOn {
            title
          }
        }
        guests {
          guestsNumber
          totalPrice
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
      }
    }
    numberOfBookingsPages(
      businessOwnerId: $businessOwnerId
      isCanceled: $isCanceled
      isHistory: $isHistory
      isHandled: $isHandled
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      totalBookingsNumber {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
      pages {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
    }
  }
`;

export const ACTIVITIES_BOOKINGS = gql`
  query activitiesBooking(
    $page: Int
    $orderBy: String
    $isHandled: Boolean
    $isHistory: Boolean
    $isCanceled: Boolean
    $startPeriod: Date
    $endPeriod: Date
    $businessOwnerId: Int
    $search: String
  ) {
    activitiesBookings(
      page: $page
      orderBy: $orderBy
      isHandled: $isHandled
      isCanceled: $isCanceled
      isHistory: $isHistory
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      businessOwnerId: $businessOwnerId
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      id
      trekksoftId
      referenceNumber
      schedule
      creationTime
      cancellationTime
      startingDate
      endingDate
      deactivationBooking
      checkInTime
      checkOutTime
      isHandled
      isCanceledWithMain
      isCanceled
      isRelated
      bookingType
      activityNotes
      guestFirstName
      guestPhoneNumber
      guestEmail
      platform
      guestLastName
      activity {
        id
        title
        schedule
        isPrivate
        productCode
        pricesType
        scheduleType
        maxParticipants
      }
      bookedAddOns {
        addOnCount
        totalPrice
        addOn {
          title
        }
      }
      guests {
        guestsNumber
        totalPrice
        participant {
          participant
        }
      }
      payments {
        currency {
          currency
        }
        totalPrice
      }
      relatedAccommodationBooking {
        id
        fromDate
        toDate
        accommodation {
          id
          title
          prices {
            day
          }
        }
        guests {
          totalPrice
          guestsNumber
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        bookedAddOns {
          addOn {
            title
          }
          totalPrice
          addOnCount
        }
      }
    }
    numberOfBookingsPages(
      isCanceled: $isCanceled
      isHistory: $isHistory
      isHandled: $isHandled
      businessOwnerId: $businessOwnerId
      numberOfBookingsPerPage: 11
      search: $search
    ) {
      totalBookingsNumber {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
      pages {
        allBookings
        activitiesBookings
        accommodationsBookings
      }
    }
  }
`;
